module.exports = __webpack_public_path__ + "static/media/fifa2020.0cfc1147.jpg";